
export type GetProjectsSortDirection = typeof GetProjectsSortDirection[keyof typeof GetProjectsSortDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
